import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

export function AddChildModal({addNewChild, setIsLoading}) {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        dob: '',
        gender: '',
        school: '',
        schoolYear: '',
        mealBenefit: '',
        allergies: false,
        allergiesText: '',
        special: false,
        specialText: '',
        inhaler: false,
        inhalerText: '',
        dislikes: false,
        dislikesText: '',
        favourites: true,
        favouritesText: '',
        status: 'pending'
    });
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setCurrentStep(0);
        setFormData({
            firstName: '',
            lastName: '',
            dob: '',
            gender: '',
            school: '',
            schoolYear: '',
            mealBenefit: '',
            allergies: false,
            allergiesText: '',
            special: false,
            specialText: '',
            inhaler: false,
            inhalerText: '',
            dislikes: false,
            dislikesText: '',
            favourites: false,
            favouritesText: '',
            status: 'pending'
        });
    };
    const handleShow = () => setShow(true);
    const [currentStep, setCurrentStep]= useState(0);

    const showNextStep = (stepData) => {
        let newData = {...formData, ...stepData};
        setFormData(newData);
        if (currentStep >=1) {
            setIsLoading(true);
            addNewChild(newData);
            setIsLoading(false);
        }
        setCurrentStep(currentStep+1);
    };
    const showBackStep = (stepData) => {
        let newData = {...formData, ...stepData};
        setFormData(newData);
        setCurrentStep(currentStep-1);
    };

    const steps = [
        <StepOne data={formData} incrementStep={showNextStep} handleClose={handleClose} />,
        <StepTwo data={formData} incrementStep={showNextStep} decrementStep={showBackStep} handleClose={handleClose} />
    ];

    return (
        <>
            <div className='d-flex justify-content-end mb-3'>
                <Button variant='secondary' className='corner-radius px-3' onClick={handleShow}>Register Child</Button>
            </div>

            <Modal 
                show={show} 
                onHide={handleClose} 
                centered
                fullscreen
            >
                <Modal.Header closeButton>
                    <Modal.Title>Register Child</Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-0'>
                    {steps[currentStep]}
                </Modal.Body>
            </Modal>
        </>
    );
}
